import { AppRegistry } from 'react-native';
import App from './src/App';
import { name as appName } from './package.json';

// Register service worker (will be implemented in later tasks)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Service worker registration will be added in task 8
    // navigator.serviceWorker.register('/service-worker.js');
  });
}

// Register the app component
AppRegistry.registerComponent(appName, () => App);

// Run the application
AppRegistry.runApplication(appName, {
  rootTag: document.getElementById('root'),
});
